"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var reselect_1 = require("reselect");
var utils_1 = require("utils/selectors/utils");
var FormAutocomplete_1 = __importDefault(require("./FormAutocomplete"));
var selectInvoiceTemplates = (0, utils_1.makeSelectOrdered)('invoice_templates');
var selectInvoiceTemplateOptions = (0, reselect_1.createSelector)(selectInvoiceTemplates, function (invoiceTemplates) { return invoiceTemplates
    && invoiceTemplates.map(function (invTempl) { return ({ value: invTempl.inPlatformId, label: invTempl.name }); }); });
var FieldCountryCodeSelect = function (_a) {
    var name = _a.name;
    var invTemplOptions = (0, react_redux_1.useSelector)(selectInvoiceTemplateOptions);
    return ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: FormAutocomplete_1.default, name: name, options: invTemplOptions !== null && invTemplOptions !== void 0 ? invTemplOptions : [], size: "small", label: "Select Template", placeholder: "Select Template", disableClearable: true }));
};
exports.default = FieldCountryCodeSelect;
